import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, onSnapshot } from "firebase/firestore";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { motion } from "framer-motion";
import ProductCard from './ProductCard';

const fadeIn = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } }
};

const FeaturedProductsCarousel = ({ onAddToCart, onViewDetail }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    // Solo productos destacados
    const unsub = onSnapshot(collection(db, "productos"), (snap) => {
      setProducts(
        snap.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(p => p.isFeatured)
      );
    });
    return () => unsub();
  }, []);

  if (!products.length) return null;

  return (
    <motion.section
      className="container mx-auto p-6 my-12"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.15 }}
      variants={fadeIn}
    >
      <motion.h2
        className="text-3xl font-bold text-gray-800 mb-8 text-center"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        Productos Destacados
      </motion.h2>

      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop
        spaceBetween={18}
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 2 },
          900: { slidesPerView: 3 },
          1200: { slidesPerView: 4 }
        }}
        className="pb-6"
      >
        {products.map(product => (
          <SwiperSlide key={product.id}>
            <motion.div
              className="relative"
              whileHover={{ scale: 1.03, boxShadow: "0 12px 32px 0 rgba(38,110,255,0.10)" }}
            >
              {product.isFeatured && (
                <span className="absolute top-2 left-2 bg-yellow-500 text-white text-xs px-3 py-1 rounded-full font-semibold shadow">
                  Destacado
                </span>
              )}
              <ProductCard
                product={product}
                onAddToCart={onAddToCart}
                onViewDetail={onViewDetail}
              />
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
    </motion.section>
  );
};

export default FeaturedProductsCarousel;
